// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Deutsche Beschriftungen für die englischen Datenset-Werte (Filter/Anzeige).
export const BODY_PART_DE: Record<string, string> = {
  back: "Rücken",
  cardio: "Cardio",
  chest: "Brust",
  "lower arms": "Unterarme",
  "lower legs": "Waden",
  neck: "Nacken",
  shoulders: "Schultern",
  "upper arms": "Oberarme",
  "upper legs": "Beine",
  waist: "Rumpf & Bauch",
}

export const EQUIPMENT_DE: Record<string, string> = {
  assisted: "assistiert",
  band: "Band",
  barbell: "Langhantel",
  "body weight": "Körpergewicht",
  "bosu ball": "Bosu-Ball",
  cable: "Kabelzug",
  dumbbell: "Kurzhantel",
  "elliptical machine": "Crosstrainer",
  "ez barbell": "SZ-Stange",
  hammer: "Hammer",
  kettlebell: "Kettlebell",
  "leverage machine": "Maschine",
  "medicine ball": "Medizinball",
  "olympic barbell": "Langhantel (olympisch)",
  "resistance band": "Widerstandsband",
  roller: "Rolle",
  rope: "Seil",
  "skierg machine": "SkiErg",
  "sled machine": "Schlitten",
  "smith machine": "Multipresse",
  "stability ball": "Gymnastikball",
  "stationary bike": "Ergometer",
  "stepmill machine": "Treppensteiger",
  tire: "Reifen",
  "trap bar": "Trap-Bar",
  "upper body ergometer": "Oberkörper-Ergometer",
  weighted: "mit Zusatzgewicht",
  "wheel roller": "Bauchroller",
}

export const BLOCK_DE: Record<string, string> = {
  warmup: "Aufwärmen",
  core: "Rumpf",
  strength: "Kraft",
  cooldown: "Abschluss",
}

export const bodyPartDe = (v: string): string => BODY_PART_DE[v] ?? v
export const equipmentDe = (v: string): string => EQUIPMENT_DE[v] ?? v
export const blockDe = (v: string): string => BLOCK_DE[v] ?? v
